import { useServiceOptional } from '@toeverything/infra';
import { useEffect, useState } from 'react';

import { WorkspaceService } from '../services/workspace';
import { resolveWorkspaceBlobFromCacheOrRemote } from '../utils/blob-cache';

export function useWorkspaceBlobContext(
  workspaceId: string | null | undefined
) {
  const workspace = useServiceOptional(WorkspaceService)?.workspace;
  if (!workspace || workspace.id !== workspaceId) return;
  return workspace.blobContext;
}

export function useWorkspaceBlobObjectUrl(
  workspaceId: string | null | undefined,
  blobId: string | null | undefined
): string | null {
  const context = useWorkspaceBlobContext(workspaceId);
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    let nextObjectUrl: string | null = null;
    setObjectUrl(null);

    if (!workspaceId || !blobId || !context) return;

    void resolveWorkspaceBlobFromCacheOrRemote({
      workspaceId,
      key: blobId,
      context,
    })
      .then(blob => {
        if (!blob || cancelled) return;
        context.assertActive();
        nextObjectUrl = URL.createObjectURL(blob);
        setObjectUrl(nextObjectUrl);
      })
      .catch(() => undefined);

    return () => {
      cancelled = true;
      if (nextObjectUrl) URL.revokeObjectURL(nextObjectUrl);
    };
  }, [blobId, workspaceId, context]);

  return objectUrl;
}
